module.exports = __webpack_public_path__ + "img/icon09.95c92a61.png";